enum ActionTypes {
    OPEN = "moveResources/open",
    CLOSE = "moveResources/close",
    MOVE = "moveResources/move",
    MOVE_SUCCESS = "moveResources/moveSuccess"
}

export default ActionTypes;
